// extracted by mini-css-extract-plugin
module.exports = {"filters":"_2787e5dfdf--filters--eHLIN"};